import { Link as RouterLink } from "react-router-dom";

export function Link({ url, children, ...rest }) {
  return (
    <RouterLink to={url} {...rest}>
      {children}
    </RouterLink>
  );
}
